import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { resetPassword } from "@/api/client";

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }

    if (!token) {
      setError("Missing reset token");
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, password);
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="space-y-4 text-center">
        <p className="text-sm text-ok">Password reset successfully!</p>
        <p className="text-sm text-ink-3">Redirecting to login...</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <p className="text-sm text-ink-3">Enter your new password.</p>
      <div className="space-y-2">
        <label className="text-sm font-medium text-ink-2">New password</label>
        <input
          type="password"
          required
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input px-3.5 py-2.5 text-sm"
          placeholder="Min 8 characters"
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-medium text-ink-2">Confirm password</label>
        <input
          type="password"
          required
          minLength={8}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          className="input px-3.5 py-2.5 text-sm"
          placeholder="Repeat password"
        />
      </div>
      {error && <p className="text-sm text-bad">{error}</p>}
      <button
        type="submit"
        disabled={loading}
        className="btn btn--accent w-full px-3.5 py-2.5 text-sm shadow-sm"
      >
        {loading ? "Resetting..." : "Reset password"}
      </button>
      <p className="text-center text-sm text-ink-3">
        <Link to="/login" className="text-ink-2 transition-colors hover:text-ink">
          Back to login
        </Link>
      </p>
    </form>
  );
}
